import { ICheckedFilter } from 'types/location.js';
import { LegendsFilterToggle } from './legends-filter-toggle.js';
import { LegendsFilter } from './legends-filter.js';

export interface LegendsCheckboxFilterProps {
  checkboxFilters?: Array<ICheckedFilter>;
  checkboxFilterOnClick: (filter: ICheckedFilter) => void;
  checkBoxFilterLabel?: string;
}

const DEFAULT_CHECKBOX_FILTER_LABEL = 'Filters';

export const LegendsFilters = ({
  checkboxFilters,
  checkBoxFilterLabel,
  checkboxFilterOnClick,
}: LegendsCheckboxFilterProps) => {
  if (checkboxFilters) {
    /** If RadioFilter labels are populated and don't include an item with label `all` then add one */
    const toggleAllFilter = checkboxFilters.length > 1;

    return (
      <>
        {checkboxFilters.length > 0 && (
          <p className="h2 u-pB-xs u-bB-1 u-mB-sm">{checkBoxFilterLabel || DEFAULT_CHECKBOX_FILTER_LABEL}</p>
        )}

        {toggleAllFilter && (
          <LegendsFilterToggle
            filters={checkboxFilters}
            key={0}
            idx={0}
            className={'u-mB-sm'}
            checkboxFilterOnClick={checkboxFilterOnClick}
          />
        )}

        {checkboxFilters.map((filter, idx) => {
          const index = toggleAllFilter ? idx + 1 : idx;
          const className = checkboxFilters.length !== index + 1 ? 'u-mB-sm' : '';
          return (
            <LegendsFilter
              filter={filter}
              key={index}
              idx={index}
              className={className}
              checkboxFilterOnClick={checkboxFilterOnClick}
            />
          );
        })}
      </>
    );
  }
  return null;
};
